import React from 'react';
import styles from './QuarterOrder.module.css';

const QuarterOrder = ({ quarters, currentTime, getTeamColor, formatTime }) => {
  // 현재 시간 라인의 위치 계산
  const calculateCurrentTimePosition = () => {
    try {
      const firstQuarterStart = new Date(quarters[0].startTime);
      const lastQuarterEnd = new Date(quarters[quarters.length - 1].startTime);
      lastQuarterEnd.setMinutes(lastQuarterEnd.getMinutes() + quarters[quarters.length - 1].duration);

      const totalTimeRange = lastQuarterEnd.getTime() - firstQuarterStart.getTime();

      if (currentTime.getTime() < firstQuarterStart.getTime()) {
        return 0;
      }

      if (currentTime.getTime() > lastQuarterEnd.getTime()) {
        return 100;
      }

      const elapsedTime = currentTime.getTime() - firstQuarterStart.getTime();
      const percentage = (elapsedTime / totalTimeRange) * 100;

      return percentage;
    } catch (error) {
      console.error('현재 시간 위치 계산 오류:', error);
      return -1;
    }
  };

  const currentTimePosition = calculateCurrentTimePosition();
  const showCurrentTimeLine = currentTimePosition >= 0 && currentTimePosition <= 100;

  const findCurrentQuarter = () => {
    for (let i = 0; i < quarters.length; i++) {
      const quarterStart = new Date(quarters[i].startTime);
      const quarterEnd = new Date(quarterStart);
      quarterEnd.setMinutes(quarterEnd.getMinutes() + quarters[i].duration);

      if (currentTime >= quarterStart && currentTime <= quarterEnd) {
        return i;
      }
    }
    return -1;
  };

  const currentQuarterIndex = findCurrentQuarter();

  return (
    <div className={styles.quartersList}>
        {/* 현재 시간 라인 */}
        {showCurrentTimeLine && (
          <div 
            className={styles.currentTimeLine}
            style={{ top: `${currentTimePosition}%` }}
          >
            <div className={styles.currentTimeLabel}>
              {formatTime(currentTime)}
            </div>
            <div className={styles.currentTimeLineBar}></div>
          </div>
        )}
        
        {quarters.map((quarter, index) => (
          <div 
            key={quarter.number} 
            className={`${styles.quarterItem} ${index === currentQuarterIndex ? styles.currentQuarter : ''}`}
          >
            <div className={styles.quarterHeader}>
              <span className={styles.quarterNumber}>{quarter.number}쿼터</span>
              <span className={styles.quarterTime}>{formatTime(quarter.startTime)}</span>
            </div>
            <div className={styles.quarterMatchup}>
              {quarter.matchup.map((teamName, index) => (
                <React.Fragment key={teamName}>
                  <div className={styles.matchupTeamContainer}>
                    <div className={styles.matchupTeam}>
                      <span 
                        className={styles.teamColorCircle} 
                        style={{ backgroundColor: getTeamColor(teamName) }}
                      ></span>
                      <span className={styles.teamNameText}>
                        {(teamName)}
                      </span>
                    </div>
                    <div className={styles.matchupTeamInfo}>
                      {quarter.restPlayers[teamName] && quarter.restPlayers[teamName].length > 0 && (
                        <span className={styles.matchupInfoItem}>
                          휴식: {quarter.restPlayers[teamName].join(', ')}번
                        </span>
                      )}
                      {quarter.scoreRotationTeams && quarter.scoreRotationTeams[teamName] ? (
                        <span className={styles.matchupInfoItem}>
                          키퍼: <span className={styles.scoreRotation}>득점시 교체</span>
                        </span>
                      ) : (
                        quarter.keeperPlayers[teamName] && quarter.keeperPlayers[teamName].length > 0 && (
                          <span className={styles.matchupInfoItem}>
                            키퍼: {quarter.keeperPlayers[teamName].join(', ')}번
                          </span>
                        )
                      )}
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
        ))}
      </div>
  );
};

export default QuarterOrder; 